/**
 * Handlers for UI interactions (selection, column resize, etc.)
 */

export const createUiHandlers = (
  products,
  selectedProductIds,
  setSelectedProductIds,
  expandedProducts,
  setExpandedProducts,
  columnVisibility,
  setColumnVisibility,
  setViewMode,
  columnWidths,
  setColumnWidths
) => {
  /**
   * Handle selecting all products
   */
  const handleSelectAll = () => {
    console.log('Selecting all products...');
    if (selectedProductIds.size === products.length) {
      setSelectedProductIds(new Set());
    } else {
      setSelectedProductIds(new Set(products.map(p => p.id.toString())));
    }
  };

  /**
   * Handle selecting a single product
   */
  const handleProductSelect = (productId) => {
    console.log('Handling product selection for ID:', productId);
    setSelectedProductIds(prev => {
      const newSelected = new Set(prev);
      if (newSelected.has(productId)) {
        console.log('Removing product from selection:', productId);
        newSelected.delete(productId);
      } else {
        console.log('Adding product to selection:', productId);
        newSelected.add(productId);
      }
      return newSelected;
    });
  };

  /**
   * Handle expanding/collapsing a product
   */
  const handleExpandToggle = (productId) => {
    setExpandedProducts(prev => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(productId)) {
        newExpanded.delete(productId);
      } else {
        newExpanded.add(productId);
      }
      return newExpanded;
    });
  };

  /**
   * Handle toggling column visibility
   */
  const toggleColumnVisibility = (index) => {
    setColumnVisibility(prev => {
      const newVisibility = [...prev];
      newVisibility[index] = !newVisibility[index];
      return newVisibility;
    });
  };

  /**
   * Toggle all columns visibility
   * @param {boolean} visible - Whether to show or hide all columns
   */
  const toggleAllColumnsVisibility = (visible) => {
    console.log(`Setting all columns visibility to: ${visible}`);
    setColumnVisibility(prev => {
      // Always keep the first two columns (Checkbox and Image) visible
      return prev.map((_, index) => {
        // Always keep the first two columns visible for usability
        if (index < 2) {
          return true;
        }
        return visible;
      });
    });
  };

  /**
   * Handle changing view mode
   */
  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  /**
   * Handle starting column resize
   */
  const handleResizeStart = (e, header) => {
    e.preventDefault();
    e.stopPropagation();
    
    const startX = e.clientX;
    const startWidth = columnWidths[header] || 100;
    
    const handleResizeMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + (moveEvent.clientX - startX));
      setColumnWidths(prev => ({
        ...prev,
        [header]: newWidth
      }));
    };
    
    const handleResizeEnd = () => {
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeEnd);
    };
    
    document.addEventListener('mousemove', handleResizeMove);
    document.addEventListener('mouseup', handleResizeEnd);
  };

  return {
    handleSelectAll,
    handleProductSelect,
    handleExpandToggle,
    toggleColumnVisibility,
    toggleAllColumnsVisibility,
    handleViewModeChange,
    handleResizeStart
  };
};
